import { render, staticRenderFns } from "./setores-editar.vue?vue&type=template&id=60ba2e05&"
import script from "./setores-editar.vue?vue&type=script&lang=js&"
export * from "./setores-editar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports